export default "__VITE_ASSET__PHtyjqGi__"